import { createRef, PureComponent } from 'react';
import type { ReactNode, RefObject } from 'react';

interface Props {
  x: number;
  children: ReactNode;
  handleWidthUpdate: (width: number) => void;
}

class PriceChartEventLabelText extends PureComponent<Props> {
  private text: RefObject<SVGTextElement>;

  constructor(props: Props) {
    super(props);
    this.text = createRef<SVGTextElement>();
  }

  componentDidMount() {
    const { handleWidthUpdate } = this;
    handleWidthUpdate();
  }

  componentDidUpdate() {
    const { handleWidthUpdate } = this;
    handleWidthUpdate();
  }

  handleWidthUpdate = () => {
    const {
      text: { current },
    } = this;
    const { handleWidthUpdate } = this.props;
    if (!current) return;
    handleWidthUpdate && handleWidthUpdate(current.getBBox().width);
  };

  render() {
    const { text } = this;
    const { x, children } = this.props;
    return (
      <text x={x} y={10} ref={text} fill="white" fontSize="12" textAnchor="end">
        {children}
      </text>
    );
  }
}

export default PriceChartEventLabelText;
